import React, { useState } from "react";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import styled from "@emotion/styled";
import { MapMarker } from ".";
import { mapStyle } from "../theme/map-style";

type location = {
    position: google.maps.LatLng | google.maps.LatLngLiteral;
    text: string;
    image: string;
};
interface MapProps {
    articleRefs: React.RefObject<HTMLDivElement>[];
    data: location[];
    zoom: number;
}
interface MarkersProps {
    articleRefs: React.RefObject<HTMLDivElement>[];
    locations: location[];
}

const containerStyle = {
    width: "100%",
    height: "100%",
    padding: 0,
};

const center = {
    lat: 62.98583179,
    lng: 16.321998712,
};

const MapContainer = styled.div`
    width: 100%;
    height: 100vh;
    max-height: 697.8px;
    padding: 0;
`;

// Markup
const MapComponent = ({ articleRefs, data, zoom }: MapProps) => (
    <MapContainer>
        <LoadScript googleMapsApiKey="AIzaSyC6saIqcHQ0_YxlnRMiHJfdIjPslDlZvBM">
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoom}
                options={{
                    styles: mapStyle,
                    disableDefaultUI: true,
                    gestureHandling: "none",
                    draggableCursor: "default",
                }}
            >
                <MapMarkers locations={data} articleRefs={articleRefs} />
            </GoogleMap>
        </LoadScript>
    </MapContainer>
);

const MapMarkersContainer = styled.div`
    position: relative;
`;

const MapMarkers = ({ locations, articleRefs }: MarkersProps) => {
    const [active, setActive] = useState<number | null>(null);

    return (
        <MapMarkersContainer>
            {locations.map(({ position, image, text }, idx) => (
                <MapMarker
                    key={`marker-${idx}`}
                    articleRef={articleRefs[idx]}
                    idx={idx}
                    position={position}
                    text={text}
                    image={image}
                    active={active}
                    setActive={setActive}
                />
            ))}
        </MapMarkersContainer>
    );
};

export const Map = React.memo(MapComponent);
